export default "__VITE_ASSET__YSp2lsRV__"